module.exports = __webpack_public_path__ + "img/warning-red.d4857a25.svg";